module.exports = __webpack_public_path__ + "static/img/apple-2.8a70e111.jpg";